import React from 'react';
import { Link } from 'react-router-dom';

export const Footer = () => {
  return (
    <footer className="bg-primary text-primary-foreground mt-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <h3 className="text-2xl font-heading font-light mb-4" data-testid="footer-brand">
              Healer Marah
            </h3>
            <p className="text-sm leading-relaxed text-stone-300 mb-6">
              Revolutionary SAC® calcium ion delivery system. 20 years of dedicated research,
              transforming the way we heal our bodies with the power of oyster shell technology.
            </p>
            <p className="text-xs text-stone-400">
              www.HealerMarah.com
            </p>
            <p className="text-xs font-mono uppercase tracking-widest text-stone-400">
              Pure • Safe • Effective
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm uppercase tracking-widest mb-4" data-testid="footer-quick-links">
              Quick Links
            </h4>
            <ul className="space-y-2 text-sm text-stone-300">
              <li>
                <Link to="/shop" className="hover:text-white transition-colors">
                  Shop All Products
                </Link>
              </li>
              <li>
                <Link to="/about" className="hover:text-white transition-colors">
                  Our Story
                </Link>
              </li>
              <li>
                <Link to="/science" className="hover:text-white transition-colors">
                  The Science
                </Link>
              </li>
              <li>
                <Link to="/cart" className="hover:text-white transition-colors">
                  Shopping Cart
                </Link>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h4 className="text-sm uppercase tracking-widest mb-4" data-testid="footer-support">
              Support
            </h4>
            <ul className="space-y-2 text-sm text-stone-300">
              <li>
                <Link to="/contact" className="hover:text-white transition-colors">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-stone-700 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center text-sm text-stone-400">
          <p data-testid="footer-copyright">© 2025 Healer Marah. All rights reserved.</p>
          <div className="flex space-x-6 mt-4 md:mt-0">
            <a href="#" className="hover:text-white transition-colors">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};